
const CareCommentThreadIdType = Symbol();

export class CareCommentThreadId {
    [CareCommentThreadIdType]: any;
    readonly value: string;

    private constructor(careCommentThreadId: string) {
        this.value = careCommentThreadId;
    }

    static fromString(careCommentThreadId: string): CareCommentThreadId {
        return new CareCommentThreadId(careCommentThreadId);
    }
}
